import React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MetaTouchpoint from '../../../../../components/Touchpoints/MetaTouchpoint/MetaTouchpoint';

export default function MetaAccordion() {
  return (
    <Accordion
      disableGutters
      sx={{
        '& .MuiAccordionSummary-root': {
          backgroundColor: 'white',
          alignItems: 'center',
          height: '48px',
          borderBottom: '1px solid #C7D8F9',
          borderTop: '1px solid #C7D8F9',
          pl: 0,

          '& .MuiAccordionSummary-content': {
            textAlign: 'center',
            height: 'initial',
          },
          '& .MuiAccordionSummary-expandIconWrapper': {
            marginRight: 0,
          },
        },
      }}
      defaultExpanded
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <Typography
          sx={{
            display: 'flex',
            alignItems: 'center',
            fontWeight: 700,
          }}
        >
          META
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ background: '#F6F6F6', p: '22px 16px' }}>
        <MetaTouchpoint />
      </AccordionDetails>
    </Accordion>
  );
}
